/* eslint-disable */

import { useEffect } from 'react';
// import { v4 as uuidv4 } from 'uuid';
// import CryptoJS from 'crypto-js';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button, Box } from '@mui/material';
import { globalNotifyError } from './utilities/AlertToast';
import { sdkInputGeneratorApi } from 'utils/API/Merchant APIs/AepsApiCalls';
import { LoadingButton } from '@mui/lab';
import CommissionDisplayComponent from './bankingServices/money transfer/CommissionDisplayComponent';
import { getDmtChargesApi } from 'utils/API/Merchant APIs/DmtApiCalls';
import Spinner from './Components/LoadingSinner';
import { checkMerchantOrBCAPI, getPremiumBcChargesNewApi } from 'utils/API/Merchant APIs/MerchantApiCalls';
import BcConvertModal from './Components/BcConvertModal';

const AepsSDK = (props) => {
    const [amountDialogOpen, setAmountDialogOpen] = useState(false);
    const [amountResponse, setAmountResponse] = useState({});
    const [amountValue, setAmountValue] = useState('');
    const [amountSubmitLoading, setAmountSubmitLoading] = useState(false);
    const [amountsLoading, setAmountsLoading] = useState(false);
    const [plansToDisplay, setPlansToDisplay] = useState({ normal: {}, silver: {}, gold: {} });
    const [merchantModalOpen, setMerchantModalOpen] = useState(false);
    const [isBcConvertPending, setIsBcConvertPending] = useState(false);
    const [isCheckLoading, setIsCheckLoading] = useState(false);
    const navigate = useNavigate();
    const shouldshowEsign = localStorage.getItem('shouldshowEsign');

    let title;
    // const className = 'zoom-and-spin';
    if (props.serviceName === 'balance-enquiry') {
        title = 'AEPS - BALANCE ENQUIRY';
        pagename = 'BALANCE_ENQUIRY';
        // eslint-disable-next-line
    } else if (props.serviceName === 'aadhaar-pay') {
        title = 'AEPS - ADHAAR PAY';
        pagename = 'ADHAAR_PAY';
        // eslint-disable-next-line
    } else if (props.serviceName === 'mini-statement') {
        title = 'AEPS - MINI STATEMENT';
        pagename = 'MINI_STATEMENT';
        // eslint-disable-next-line
    } else if (props.serviceName === 'cash-withdrawal') {
        title = 'AEPS - CASH WITHDRAWAL ';
        pagename = 'CASH_WITHDRAWAL';
    } else if (props.serviceName === 'cash-deposit') {
        title = 'AEPS - CASH DEPOSIT ';
        pagename = 'CASH_DEPOSIT';
    } else {
        title = 'AEPS ';
        pagename = 'AEPS';
    }
    const handleBcModalClose = () => {
        setMerchantModalOpen(false);
    };
    const handleCheckMerchantOrBc = async () => {
        //CHECKING FOR  MERCHANT OR BC
        setIsCheckLoading(true);
        const agentid = localStorage.getItem('id');
        const payload = { agentid };
        const merchantBcCheckResponse = await checkMerchantOrBCAPI(payload);
        setIsCheckLoading(false);
        const agentType = merchantBcCheckResponse?.data?.agentType;
        const pendingStatus = merchantBcCheckResponse?.data?.isPending;
        setIsBcConvertPending(pendingStatus);

        if (agentType === 'Merchant' || pendingStatus || shouldshowEsign === 'true') {
            // setMerchantModalOpen(true);
            // return true;
        }
        return false;
        //CHECKING ENDS HERE
    };
    useEffect(() => {
        const checkStatus = async () => {
            try {
                const status = await handleCheckMerchantOrBc(); // Await the promise
                if (!status) {
                    // Execute the rest of the logic only if status is true
                    const script = document.createElement('script');
                    script.src = '/isuSDK.min.js';
                    script.async = true;
                    script.onload = () => {
                        if (props.serviceName === 'balance-enquiry' || props.serviceName === 'mini-statement') {
                            // handleSubmit();
                            getInputObject();
                        } else {
                            setAmountDialogOpen(true);
                        }
                    };

                    document.body.appendChild(script);
                    getPremiumPlansAndCharges();
                    // Cleanup function to remove the script tag if the component unmounts
                    return () => {
                        document.body.removeChild(script);
                    };
                }
            } catch (error) {
                console.error('Error in API call:', error);
            }
        };

        checkStatus();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = (sdkOptions) => {
        isuSDK('#uaeps').open(sdkOptions);
        navigate('/merchant-home');
    };

    //amount handlers
    // Handler for input changes
    const handleAmountChange = (e) => {
        const inputValue = e.target.value;
        const regex = /^$|^[0-9]+$/;

        if (regex.test(inputValue) && (inputValue === '' || parseInt(inputValue, 10) <= 100000)) {
            setAmountValue(inputValue);
        }
    };

    // Handler for form submission
    const handleSubmitAmount = () => {
        if (!amountValue || isNaN(amountValue) || parseFloat(amountValue) <= 0) {
            globalNotifyError('Please enter a valid amount.');
            return;
        }
        getInputObject(); // Pass the validated amount back
    };

    const handleClose = () => {
        setAmountValue('');
        setAmountDialogOpen(false);
        navigate('/merchant-home');
    };

    //api call
    const getInputObject = async () => {
        setAmountSubmitLoading(true);
        const payload = { type: pagename, txn_amount: amountValue };
        const response = await sdkInputGeneratorApi(payload);
        if (response?.status === 200) {
            const sdkInputData = response?.data?.data;
            handleSubmit(sdkInputData);
            setAmountValue(''); // Clear the input
        } else {
            navigate('/merchant-home');
        }
        setAmountSubmitLoading(false);
    };
    const handleGetChargesApi = async () => {
        if (amountValue < 100) {
            setAmountResponse({});
            globalNotifyError('The amount must be at least ₹100.');
            return;
        }
        setAmountsLoading(true);
        const uid = localStorage.getItem('id');
        let serviceType = 'AEPS';
        if (props.serviceName === 'cash-deposit') {
            serviceType = 'CASH_DEPOSIT';
        }
        const payload = { uid, tamount: amountValue, serviceType };
        const response = await getDmtChargesApi(payload);
        if (response?.status === 200) {
            setAmountResponse(response?.data);
        }
        setAmountsLoading(false);
    };
    const getPremiumPlansAndCharges = async () => {
        const agentid = localStorage.getItem('id');
        const payload = { agentid };
        const response = await getPremiumBcChargesNewApi(payload);
        const data = response?.data?.data;
        const normalPlan = data?.find((item) => item.id === 1);
        const silverPlan = data?.find((item) => item.id === 3);
        const goldPlan = data?.find((item) => item.id === 2);
        setPlansToDisplay({ normal: normalPlan, silver: silverPlan, gold: goldPlan });
    };
    return (
        <div>
            <div id="uaeps"></div>
            <Dialog
                open={amountDialogOpen}
                onClose={handleClose}
                fullWidth
                maxWidth="md"
                sx={{
                    '& .MuiDialog-paper': {
                        borderRadius: '16px',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
                        padding: '16px'
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        fontWeight: 'bold',
                        fontSize: '1.3rem',
                        textAlign: 'center',
                        color: 'primary.main'
                    }}
                >
                    Please enter the transaction amount to proceed
                </DialogTitle>
                <DialogContent
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 2
                    }}
                >
                    <TextField
                        sx={{
                            marginTop: 2,
                            '& .MuiInputBase-root': {
                                borderRadius: '8px',
                                fontSize: '1.1rem'
                            }
                        }}
                        label="Amount"
                        type="text"
                        fullWidth
                        value={amountValue}
                        onChange={handleAmountChange}
                        autoFocus
                        onBlur={handleGetChargesApi}
                    />

                    {/* Submit and Cancel Buttons moved here */}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: 2,
                            marginTop: 2
                        }}
                    >
                        <Button
                            onClick={handleClose}
                            color="secondary"
                            variant="outlined"
                            sx={{
                                borderRadius: '8px',
                                textTransform: 'none',
                                fontSize: '1rem',
                                padding: '8px 16px'
                            }}
                        >
                            Cancel
                        </Button>
                        <LoadingButton
                            onClick={handleSubmitAmount}
                            color="primary"
                            variant="contained"
                            disabled={!amountValue}
                            loading={amountSubmitLoading}
                            sx={{
                                borderRadius: '8px',
                                textTransform: 'none',
                                fontSize: '1rem',
                                padding: '8px 16px',
                                boxShadow: '0 3px 8px rgba(0, 0, 0, 0.2)'
                            }}
                        >
                            Submit
                        </LoadingButton>
                    </Box>

                    {(props?.serviceName === 'cash-withdrawal' || props?.serviceName === 'cash-deposit') && amountResponse?.amount && (
                        <CommissionDisplayComponent amountResponse={amountResponse} />
                    )}
                </DialogContent>
            </Dialog>

            {merchantModalOpen && (
                <BcConvertModal
                    isOpen={merchantModalOpen}
                    handleclose={handleBcModalClose}
                    isPending={isBcConvertPending}
                    shouldshowEsign={shouldshowEsign}
                />
            )}
            <Spinner loading={isCheckLoading || amountsLoading} />
        </div>
    );
};

export default AepsSDK;
